import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7850a998"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nav-margin"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_ListViewCpt = _resolveComponent("ListViewCpt");
  const _component_PageNavBackLayoutCpt = _resolveComponent("PageNavBackLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavBackLayoutCpt, {
    class: "synthetical-commission-page"
  }, {
    default: _withCtx(() => [_createVNode(_component_ListViewCpt, {
      ref: "ListViewCpt",
      request: $data.listRequest,
      requestParameter: $data.searchForm
    }, {
      default: _withCtx(({
        item
      }) => [_hoisted_1, _createVNode(_component_van_cell_group, null, {
        default: _withCtx(() => [_createVNode(_component_van_cell, {
          title: "被推荐人工号",
          value: item.agentCode
        }, null, 8, ["value"]), _createVNode(_component_van_cell, {
          title: "被推荐人姓名",
          value: item.agentName
        }, null, 8, ["value"]), _createVNode(_component_van_cell, {
          title: "入职时间",
          value: item.joinDate
        }, null, 8, ["value"]), _createVNode(_component_van_cell, {
          title: "已入职时间(月)",
          value: item.entryMonth
        }, null, 8, ["value"]), _createVNode(_component_van_cell, {
          title: "英才奖应发",
          value: item.eliteBonus
        }, null, 8, ["value"]), _createVNode(_component_van_cell, {
          title: "超额英才奖应发",
          value: item.superEliteBonus
        }, null, 8, ["value"]), _createVNode(_component_van_cell, {
          title: "实发",
          value: item.acturalEliteBonus
        }, null, 8, ["value"])]),
        _: 2
      }, 1024)]),
      _: 1
    }, 8, ["request", "requestParameter"])]),
    _: 1
  });
}